import { render, staticRenderFns } from "./UncheckedNgSpecialOfferReceipt.vue?vue&type=template&id=1a68b1b9&scoped=true&"
import script from "./UncheckedNgSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./UncheckedNgSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./UncheckedNgSpecialOfferReceipt.vue?vue&type=style&index=0&id=1a68b1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68b1b9",
  null
  
)

export default component.exports